export enum MigrationSource {
    PAYSTONE_HUB = 'paystone_hub',
}

export enum LanguagePreference {
    EN = 'en',
    FR = 'fr',
}

export enum MFAMethod {
    SMS = 'sms',
    EMAIL = 'email',
}

export enum UserRiskProfileSource {
    CASTLE = 'castle',
}

export enum CastlePolicyAction {
    ALLOW = 'allow',
    DENY = 'deny',
    CHALLENGE = 'challenge',
}
